import {
    Theme,
    createStyles,
    makeStyles,
} from '@material-ui/core';
import {
    ArrayInput,
    CheckboxGroupInput,
    Edit,
    EditProps,
    FormDataConsumer,
    NumberInput,
    RadioButtonGroupInput,
    ReferenceArrayInput,
    SimpleFormIterator,
    TextInput,
    maxValue,
    minValue,
    required,
} from 'react-admin';
import {
    CSSTransitionProps,
} from 'react-transition-group/CSSTransition';
import {
    CompactForm,
    RaGrid,
} from 'ra-compact-ui';
import { Divider } from '../layout';
import { SaveOnlyToolbar } from '../common/SaveOnlyToolbar';
import { dayOrNightChoices } from '../types';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        none: {
            display: 'none',
        },
    }),
);

export const ContractorEdit = (props: EditProps) => {
    const classes = useStyles();
    const transitionProps: CSSTransitionProps = {
        classNames: "",
        addEndListener: () => undefined,
    };
    return (
        <Edit {...props}>
            <CompactForm layoutComponents={[RaGrid]} redirect="show" toolbar={<SaveOnlyToolbar />}>
                <RaGrid container spacing={2}>
                    <RaGrid item xs={1}>
                        <TextInput source="id" label="ID" helperText='' disabled fullWidth />
                    </RaGrid>
                </RaGrid>
                <Divider />
                <RaGrid container spacing={2}>
                    <RaGrid item xs={12}>
                        <TextInput source="name" label="名前" validate={[required()]} fullWidth />
                    </RaGrid>
                    <RaGrid item xs={12}>
                        <ReferenceArrayInput source="contractorCategoryIds" label="業種" reference="contractorCategories" validate={[required()]} fullWidth>
                            <CheckboxGroupInput />
                        </ReferenceArrayInput>
                    </RaGrid>
                    <RaGrid item xs={12}>
                        <ArrayInput source="workUnits" label="工事項目">
                            <SimpleFormIterator disableReordering TransitionProps={transitionProps}>
                                <NumberInput source="id" label="ID" formClassName={classes.none} />
                                <FormDataConsumer fullWidth>
                                    {({ getSource }) => {
                                        return getSource ? (
                                            <RaGrid container spacing={2}>
                                                <RaGrid item xs={2}>
                                                    <RadioButtonGroupInput source={getSource('dayOrNight')} label="" validate={[required()]} choices={dayOrNightChoices} fullWidth />
                                                </RaGrid>
                                                <RaGrid item xs={6}>
                                                    <TextInput source={getSource('name')} label="名前" validate={[required()]} fullWidth />
                                                </RaGrid>
                                                <RaGrid item xs={4}>
                                                    <NumberInput source={getSource('unitPrice')} label="単価" validate={[required(), minValue(0), maxValue(Number.MAX_SAFE_INTEGER)]} fullWidth />
                                                </RaGrid>
                                            </RaGrid>
                                        ) : null;
                                    }}
                                </FormDataConsumer>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </RaGrid>
                </RaGrid>
            </CompactForm>
        </Edit>
    );
};
